import React from 'react';
import { PollingExperiment, PollingExperiments } from './StandardEndpage/pollingExperiments';
import { WeightedElement } from './constants';

import StandardEndpage from './StandardEndpage';

/**
 * Using a weighted distribution, select and return the page that the target element falls on
 *
 * @param weightedElements object of pages
 * @param target value within distribution range, use a random number [0, 1) if weighted distribution adds up to 1
 * @returns Selected page to serve
 */
export default function WeightedElementSelector(
  weightedElements: WeightedElement[],
  target: number
): React.ReactElement {
  let cumulativeWeight = 0.0;
  let selectedPage = <StandardEndpage pageName="CxEndpage" utSource="survey-thanks" />;

  weightedElements.every(element => {
    cumulativeWeight += element.weight;
    if (target < cumulativeWeight) {
      selectedPage = element.page;
      return false;
    }
    return true;
  });

  return selectedPage;
}

export function checkWeightsEqualToOne(weightedElements: WeightedElement[]): boolean {
  let total = 0.0;
  weightedElements.forEach(element => {
    total += element.weight;
  });
  if (Number(total.toFixed(3)) === 1) return true;
  return false;
}

/**
 * Iterates through the experiments listed in PollingExperiments object  to see if any match the page's experiment.
 * @returns an Endpage
 */
export function renderPolling(
  alternate: React.ReactElement,
  pollingTreatment: string,
  pollingExperiment: string
): React.ReactElement {
  let toReturn = alternate;
  let pageName = '';
  PollingExperiments.every((element: PollingExperiment) => {
    if (pollingExperiment === element.experimentName) {
      pageName = element.pageName;
      return false;
    }
    return true;
  });
  if (pollingTreatment && pollingExperiment) {
    toReturn = <StandardEndpage pageName={pageName} treatmentName={pollingTreatment} utSource="survey-thanks" />;
  }
  return toReturn;
}

type pollingCookies = [
  cookie: {
    age: number;
    name: string;
    value: string;
  }
];

/**
 * If the polling experiment comes back with experiment and polling cookie
 * values to save, do that. This is mostly for logged out users, but can
 * also apply to experiment preview cookies.
 *
 * @param {*} pollingCookies The polling query cookie object returned from experimentsvc
 */
export function savePollingExperimentCookies(cookies: pollingCookies): void {
  // Set each cookie the same way it's done in <Treatment>
  const { host } = window.location;
  const domain = host.replace(/^[^.]+\./g, '');
  cookies.forEach(cookieObj => {
    document.cookie = `${cookieObj.name}=${cookieObj.value}; max-age=${cookieObj.age}; path=/; domain=${domain}; secure=true; SameSite=None`;
  });
}
